export const APPS_URL = '/apps';
